const getters = {
    getRoles: state => state.roles,
    getRolePermissions: state => state.permissions,
    saveRolePermissions: state => state.savedPermissions
}

export default getters
